import { format } from 'date-fns';

const normalizeToUtc = (date: string): string => {
  if (date.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(date)) return date;
  return date + 'Z';
};

export const formatDate = (date?: string | null) => {
  if (!date) return '';
  if (typeof date !== 'string') return `${date}`;

  const parsed = new Date(normalizeToUtc(date));
  if (isNaN(parsed.getTime())) return '';

  return format(parsed, 'yyyy-MM-dd HH:mm:ss');
};
